import z from 'zod';

export type CreateSingleReport = z.infer<typeof createSingleReportSchema>;
export type CreateMonthlyReport = z.infer<typeof createMonthlyReportSchema>;
export type CreateAnnualReport = z.infer<typeof createAnnualReportSchema>;
export type CreateCalculationReport = z.infer<typeof createCalculationsSchema>;

export const createSingleReportSchema = z.object({
  principal: z.number(),
  monthlyPaymentWithTaxesAndInsurance: z.number(),
  sumOfPayments: z.number(),
  interestCost: z.number(),
  cashToClose: z.number()
});

export const createMonthlyReportSchema = z.object({
  monthlyRevenues: z.number().array(),
  monthlyExpenses: z.number().array(),
  monthlyCashFlow: z.number().array()
});

export const createAnnualReportSchema = z.object({
  annualRevenues: z.number().array(),
  annualExpenses: z.number().array(),
  annualCashFlow: z.number().array(),
  homeValues: z.number().array(),
  principalsRemaining: z.number().array(),
  equities: z.number().array(),
  equityLessCashInvested: z.number().array(),
  cumulativeCashFlowForLoanTerm: z.number().array(),
  profitsAtSale: z.number().array(),
  totalReturns: z.number().array(),
  cashOnCashReturn: z.number().array(),
  simpleROI: z.number().array(),
  capRate: z.number().array()
});

export const createCalculationsSchema = z
  .object({
    reportInputId: z.string()
  })
  .merge(createSingleReportSchema)
  .merge(createMonthlyReportSchema)
  .merge(createAnnualReportSchema);
